<template>
    <v-app>
        <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition"
            v-model="snackbar" timeout="2000" :value="true" :color="snaclr" absolute outlined top right>
            <v-icon class="mr-2" :color="snaclr">mdi-alert-outline</v-icon>
            {{ errMsg }}
        </v-snackbar>
        <v-container class="pa-0 pa-sm-3 pa-md-3">
            <div class="px-sm-4">
                <v-toolbar dense class="elevation-0 mb-5  mt-6 pr-4" >
                    <v-toolbar-title>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold headline">Downloads </v-list-item-title>
                                <!-- <v-list-item-subtitle class="body-1 mb-0 mt-1" color="#878B93">
                                    A summary of activity over a particular financial year.
                                </v-list-item-subtitle> -->
                            </v-list-item-content>
                        </v-list-item>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="searchQuery" style="max-width: 160px" dense outlined class="mt-7 rounded-lg d-none d-md-flex"
                        color="gray" label="Search" prepend-inner-icon="mdi-magnify">
                    </v-text-field>

                </v-toolbar>
                <v-divider class="ml-3 mr-3"></v-divider>
                <div class="px-4 mt-4">
                    <v-row no-glutters v-if="filteredData.length">
        
                        <v-col
      cols="12"
      md="6"
      xl="4"
      lg="6"
      v-for="(post, index) in filteredData"
      :key="index"
    >
      <v-card
        width="100%"
        outlined
        elevation="0"
        class="box-s1 px-md-2 py-1 sec-two-sty1 rounded-xl"
      >
        <v-list-item class="pr-0">
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold fs-18">
              {{ post.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-btn
       @click="openFilesInNewTab(Object.values(post.files))"
            target="_blank"
            rel="noopener noreferrer"
            text
            plain
            color="#0037B7"
          >
            <span class="font-weight-bold text-none fs-16">Download</span>
          </v-btn>
        </v-list-item>
      </v-card>
    </v-col>

                  
                    </v-row>
                    <div v-else>
                        
                        <v-col  cols="12">
                            <v-card elevation="0" class="text-center pa-5 ">
                                <svg width="100" height="100" viewBox="0 0 100 100" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M90.0699 49.7871C89.5137 48.9418 88.6027 48.4371 87.6356 48.4371H84.3371C83.5137 28.1246 67.0277 12.498 46.8746 12.498C26.1965 12.498 9.37305 29.3215 9.37305 49.9996C9.37305 70.6777 26.1965 87.5012 46.8746 87.5012C56.6668 87.5012 65.9309 83.7512 72.9621 76.9402L70.7887 74.6934C64.3434 80.9371 55.8496 84.3762 46.8746 84.3762C27.9199 84.3762 12.498 68.9543 12.498 49.9996C12.498 31.0449 27.9199 15.623 46.8746 15.623C65.3059 15.623 80.3902 31.2496 81.2105 48.4371H77.9902C77.023 48.4371 76.1121 48.9418 75.5543 49.7871C74.934 50.7324 74.8262 51.9699 75.2777 53.0199L78.8215 61.2746C79.559 62.9934 81.0871 64.0605 82.8121 64.0605C84.5371 64.0605 86.0652 62.9918 86.8027 61.2746L90.3465 53.0199C90.798 51.9715 90.6918 50.7324 90.0699 49.7871ZM87.4746 51.7887L83.9309 60.0434C83.4418 61.1793 82.1824 61.1793 81.6934 60.0434L78.1496 51.7887C78.1137 51.7012 78.1246 51.6168 78.1402 51.5621H87.4855C87.5027 51.6168 87.5121 51.7012 87.4746 51.7887Z"
                                        fill="#CCCCCC" />
                                    <path
                                        d="M46.6625 38.5064C47.2172 38.8721 47.875 39.0596 48.5359 39.0596C48.9984 39.0596 49.4625 38.9689 49.8937 38.783L58.15 35.2392C59.8703 34.5033 60.9375 32.9736 60.9375 31.2502C60.9375 29.5267 59.8687 27.9971 58.1516 27.2596L49.8953 23.7158C48.8469 23.2658 47.6078 23.3705 46.6641 23.9924C45.8172 24.5486 45.3125 25.458 45.3125 26.4267V29.7674C34.375 30.5689 26.5625 39.3267 26.5625 50.0002C26.5625 61.2002 35.675 70.3127 46.875 70.3127C58.075 70.3127 67.1875 60.9377 67.1875 50.0002H64.0625C64.0625 59.3752 56.3516 67.1877 46.875 67.1877C37.3984 67.1877 29.6875 59.4767 29.6875 50.0002C29.6875 41.0502 35.9375 33.6846 45.3125 32.8908V36.0721C45.3125 37.0408 45.8172 37.9502 46.6625 38.5064ZM48.4375 26.5768C48.4375 26.558 48.5734 26.5502 48.6625 26.5877L56.9188 30.1314C57.4859 30.3752 57.8125 30.783 57.8125 31.2502C57.8125 31.7174 57.4859 32.1252 56.9188 32.3689L48.6625 35.9127C48.5734 35.9486 48.4375 35.9408 48.4375 35.9221V26.5768Z"
                                        fill="#CCCCCC" />
                                    <path
                                        d="M46.875 43.75C45.2174 43.75 43.6277 44.4085 42.4556 45.5806C41.2835 46.7527 40.625 48.3424 40.625 50C40.625 51.6576 41.2835 53.2473 42.4556 54.4194C43.6277 55.5915 45.2174 56.25 46.875 56.25C48.5326 56.25 50.1223 55.5915 51.2944 54.4194C52.4665 53.2473 53.125 51.6576 53.125 50C53.125 48.3424 52.4665 46.7527 51.2944 45.5806C50.1223 44.4085 48.5326 43.75 46.875 43.75Z"
                                        fill="#CCCCCC" />
                                </svg>
                                <p>No Collateral Available</p>
                            </v-card>
                        </v-col>
                    </div>

                </div>
            </div>
        </v-container>
    </v-app>
</template>


<script>
import { feedsurl } from "../apiUrl";

export default {
    data() {
        return {
            snackbar: false,
            errMsg: "",
            snaclr: "#000",
            fulluploaddataa:[],
            // baseURL: 'http://192.168.5.107:5555/',
            baseURL: 'https://pdbe.mynt.in/',
            searchQuery: "",

        }
    },
    methods:{
        showuploadfiles() {
            this.fulluploaddataa = []
            const axios = require('axios');
            let data = '';

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${feedsurl}/download_collateral`,
                headers: {},
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    if (response.data.stat == "Ok") {
                        axiosThis.fulluploaddataa = response.data.data 
                       
                    } else {
                        axiosThis.snackbar = true
                        axiosThis.errMsg = response.data.error
                        axiosThis.snaclr = "error"
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true
                    axiosThis.errMsg = error
                    axiosThis.snaclr = "error"
                });

        },
    //     downloadFiles(file) {
    //   const fullURL = this.baseURL + file;
    //   window.open(fullURL, '_blank');
      
    // }
    openFilesInNewTab(filePaths) {
  if (!Array.isArray(filePaths)) {
    console.error('Invalid filePaths input. Expected an array of file paths.');
    return;
  }

  filePaths.forEach(filePath => {
    if (filePath) {
      const fullURL = this.baseURL + filePath;

      try {
        console.log(`Attempting to open in new tab: ${fullURL}`);
        
        // Open the file URL in a new tab
        window.open(fullURL, '_blank');
      } catch (error) {
        console.error('Error opening file:', error);
      }
    }
  });
}



   
    },
    computed: {
    filteredData() {
      return this.fulluploaddataa.filter((post) =>
        post.title.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
    mounted(){
        this.showuploadfiles()
    }
}
</script>